<div *ngIf="!isCommission" class="services-indicator" (click)="dialogService.openDataServicesDialog()">
  Service Health
</div>
